export default "__VITE_ASSET__BlzJ2B9r__"